import Brand from "../pages/public/brand";
const routes = [
  {
    path: "/brand/:shop/:brandName",
    component: Brand,
  },
];

export default routes;
